<div class="field">
    @if (label()) {
        <span class="label" [id]="inputId()">{{ label() }}</span>
    }
    <cl-selectbutton
        [options]="options()"
        optionLabel="label"
        optionValue="value"
        [formControl]="control()"
        [allowEmpty]="false"
        [ariaLabelledby]="inputId()"
    />
    <app-form-error [errors]="control().errors" [visible]="control().touched && !!control().errors" />
</div>
